// extracted by mini-css-extract-plugin
module.exports = {"root":"Btn_root__9mChe"};